



















import { Vue, Component } from "vue-property-decorator";

import FormGroup from "@share/common/form/form-group/FormGroup.vue";
import BorderlessText from "@share/common/form/form-controls/text/BorderlessText.vue";

@Component({ components: { FormGroup, BorderlessText }})

export default class PostRegistraion extends Vue {
    firstName = "";
    lastName = "";
    email = "";
}

